import { render, staticRenderFns } from "./solicitudUnicaAprob2.vue?vue&type=template&id=3541d8b8&scoped=true"
import script from "./solicitudUnicaAprob2.vue?vue&type=script&lang=js"
export * from "./solicitudUnicaAprob2.vue?vue&type=script&lang=js"
import style0 from "./solicitudUnicaAprob2.vue?vue&type=style&index=0&id=3541d8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3541d8b8",
  null
  
)

export default component.exports